import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const isDashboardPath = (pathname?: string): boolean =>
  typeof pathname === 'string'
    ? pathname === '/' || pathname.startsWith(`/trade/`)
    : false;

/** Check if user is currently on Dashboard */
export const useIsDashboardRoute = () => {
  const { pathname } = useLocation();
  return useMemo(() => isDashboardPath(pathname), [pathname]);
};

export const useIsMobileBuySellRoute = () => {
  const { pathname } = useLocation();
  return useMemo(() => pathname.endsWith('/mobile-trade'), [pathname]);
};
